export default {
  getDimension: (state) => state.dimension,
};
